import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Message from '../misc/Message';

const useStyles = makeStyles((theme) => ({
  root: { marginTop: theme.spacing(6) },
}));

export default function LinesNotSupportedMobilePage() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Message text="Looks like you're using a mobile device. Please view and manage your Lines from a desktop device." />
    </div>
  );
}
